import { Component, OnInit, Output, EventEmitter, Input, ViewChild, ElementRef } from '@angular/core';

declare var $: any;

@Component({
  selector: 'confirmation-toolbox',
  templateUrl: './confirmation-toolbox.component.html'
})
export class ConfirmationToolboxComponent implements OnInit {

  @Input() data;
  @Input() showItem;
  @Output() showItemChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onConfirm = new EventEmitter();

  constructor() {
  }

  ngOnInit() {

  }

  onOk() {
    this.onConfirm.emit({ status: true, data: this.data });
    this.showItem != this.showItem;
  }
  onCancel() {
    this.onConfirm.emit({ status: false, data: this.data });
    this.showItem = false;
    this.showItemChange.emit(this.showItem);
  }

}


// WEBPACK FOOTER //
// ./src/app/modules/work/modal/confirmation-toolbox.component.ts